import writeSectionStylesToCss from './css/writeSectionStylesToCss';
import useLiveUpdateCss from './useLiveUpdateCss';
import updateBackgroundDom from './updateBackgroundDom';
export default function SectionStyleRenderer({
  section,
  breakpointMediaQueries
}) {
  const styles = section.getValue().styles;
  const css = writeSectionStylesToCss(section.getId(), styles.breakpointStyles, breakpointMediaQueries, section.getValue().dataVariant);
  useLiveUpdateCss(css);
  updateBackgroundDom(section, breakpointMediaQueries);
  return null;
}